import { render, staticRenderFns } from "./CommentMessage.vue?vue&type=template&id=f6b0f844&scoped=true&"
import script from "./CommentMessage.vue?vue&type=script&lang=js&"
export * from "./CommentMessage.vue?vue&type=script&lang=js&"
import style0 from "./CommentMessage.vue?vue&type=style&index=0&id=f6b0f844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b0f844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTooltip})
